import { useQuery } from '@tanstack/react-query';
import { crmReportsApi } from '../services';
import type {
  FunnelAnalyticsRequest,
  FunnelAnalyticsResponse,
  LeadConversionRequest,
  LeadConversionResponse,
  ActivityReportRequest,
  ActivityReportResponse,
  TeamPerformanceRequest,
  TeamPerformanceResponse,
  CRMDashboardRequest,
  CRMDashboardResponse,
} from '@troia-v3/types';

/**
 * Hook para buscar analytics de funis
 */
export const useFunnelAnalytics = (params: FunnelAnalyticsRequest) => {
  return useQuery<FunnelAnalyticsResponse[], Error>({
    queryKey: ['crm-reports', 'funnel-analytics', params],
    queryFn: () => crmReportsApi.getFunnelAnalytics(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
};

/**
 * Hook para buscar relatório de conversão de leads
 */
export const useLeadConversion = (params: LeadConversionRequest) => {
  return useQuery<LeadConversionResponse, Error>({
    queryKey: ['crm-reports', 'lead-conversion', params],
    queryFn: () => crmReportsApi.getLeadConversion(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

/**
 * Hook para buscar relatório de atividades
 */
export const useActivityReport = (params: ActivityReportRequest) => {
  return useQuery<ActivityReportResponse, Error>({
    queryKey: ['crm-reports', 'activity-report', params],
    queryFn: () => crmReportsApi.getActivityReport(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

/**
 * Hook para buscar relatório de desempenho de equipe
 */
export const useTeamPerformance = (params: TeamPerformanceRequest) => {
  return useQuery<TeamPerformanceResponse, Error>({
    queryKey: ['crm-reports', 'team-performance', params],
    queryFn: () => crmReportsApi.getTeamPerformance(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

/**
 * Hook para buscar dashboard CRM
 */
export const useCRMDashboard = (params: CRMDashboardRequest) => {
  return useQuery<CRMDashboardResponse, Error>({
    queryKey: ['crm-reports', 'dashboard', params],
    queryFn: () => crmReportsApi.getDashboard(params),
    staleTime: 2 * 60 * 1000, // 2 minutes for dashboard
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
